import { render, staticRenderFns } from "./exhibition-management.vue?vue&type=template&id=0e5881e8&scoped=true"
import script from "./exhibition-management.vue?vue&type=script&lang=js"
export * from "./exhibition-management.vue?vue&type=script&lang=js"
import style0 from "./exhibition-management.vue?vue&type=style&index=0&id=0e5881e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5881e8",
  null
  
)

export default component.exports